import React from "react";

const SvgAries = (props) => {
  return (
    <svg
      viewBox="0 0 44.37 34.31"
      {...props}
    >
      <path
        d="M32.53 0c-4.44 0-8.32 2.46-10.34 6.09C20.16 2.46 16.28 0 11.84 0 5.31 0 0 5.31 0 11.84c0 4.56 2.54 8.64 6.64 10.64a1.51 1.51 0 002.01-.69c.36-.74.05-1.64-.69-2.01A8.765 8.765 0 013 11.84C3 6.97 6.97 3 11.84 3c4.87 0 8.84 3.97 8.84 8.84v20.97c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V11.84c0-4.87 3.97-8.84 8.84-8.84 4.88 0 8.84 3.97 8.84 8.84 0 3.41-1.9 6.45-4.96 7.95-.74.36-1.05 1.26-.69 2.01.26.53.79.84 1.35.84.22 0 .45-.05.66-.15 4.1-2.01 6.64-6.08 6.64-10.64C44.37 5.31 39.06 0 32.53 0z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default SvgAries;
